import React from 'react';
import { CurrencyTotalsTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/CurrencyTotalsTable.tsx';
import type { TCurrencyExchangeCurrencyTotals } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { formatThousandAmount } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

interface ICurrencyExchangesTotalsProps {
  totals: TCurrencyExchangeCurrencyTotals[];
}

const formatOptionalAmount = (amount: number | undefined): string =>
  amount === undefined ? '' : formatThousandAmount(amount);

export const CurrencyExchangesTotals: React.FC<ICurrencyExchangesTotalsProps> = ({ totals }) => (
  <CurrencyTotalsTable
    ariaLabel="Підсумки купівлі-продажу валюти"
    headers={['Валюта', 'Продано, тис. од.', 'Куплено, тис. од.']}
    rows={totals.map(({ currency, soldAmount, boughtAmount }) => ({
      key: currency.value,
      values: [
        currency.label,
        formatOptionalAmount(soldAmount),
        formatOptionalAmount(boughtAmount),
      ],
    }))}
  />
);
